// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import BillingFieldsController from "./billing_fields_controller"
application.register("billing-fields", BillingFieldsController)

import BookingPackageController from "./booking_package_controller"
application.register("booking-package", BookingPackageController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import GenreLimitController from "./genre_limit_controller"
application.register("genre-limit", GenreLimitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstrumentRowsController from "./instrument_rows_controller"
application.register("instrument-rows", InstrumentRowsController)

import MixingPackageController from "./mixing_package_controller"
application.register("mixing-package", MixingPackageController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import ReloadAfterController from "./reload_after_controller"
application.register("reload-after", ReloadAfterController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
